import { roomApi } from '@/core/api/room'

export const { useGetEmergencyRoomsQuery, useLazyGetEmergencyRoomsQuery } = roomApi
